import React, { useLayoutEffect } from 'react';

import { useAsyncValue, useLocation, useNavigate } from 'react-router-dom';

// Components
import EditingActionForm from '../../../../../components/forms/ActionForms/ActionEdition';

// Constants
import { formActionNaming } from '../../../../../components/forms/ActionForms/constants';

// Types
import { type ActionEditionFormValues } from '../../../../../components/forms/ActionForms/ActionEdition/types';
import { type WorkOrder } from '../../../../../types/workOrder';
import { useDispatch } from 'react-redux';
import {
  actionTabs,
  actionTabsUnlockAll,
} from '../../../../../state/actions/ui/actionTabs';
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';
import { OrderType } from '../../../../../types/orders';

// Hooks
import { useAuth } from '../../../../../hooks/useAuth';

// Utils
import { roleCanViewBudgets } from '../../../../../utils/rolePermissions';
import { roleCanEditBasicSchedule } from '../../../../../components/forms/ActionForms/ActionEdition/basicSchedule';

export default function EditionFormPage(): JSX.Element {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loaderData = useAsyncValue() as ActionEditionFormValues &
    WorkOrder & { isBasicAction?: boolean };
  const { user } = useAuth();

  const currentRole = user?.user?.rolActive;

  useLayoutEffect(() => {
    dispatch(
      roidOTSelected(
        OrderType.Action,
        loaderData.breadCrumbsData.orderParentRoid,
        loaderData.breadCrumbsData.orderParentId
      )
    );
  }, []);

  const onFormSubmit = () => {
    // FR-9.3 simplificado (feedback usuario 2026-07-21): los toggles
    // "Incluye en esta actuación" sobraban — las tabs Materiales/Animales ya
    // llevan su propio switch "No hay". En SR el flujo sigue las tabs
    // estándar del Tablet (materials → animals → summary/cierre).
    //
    // 2026-08-07: la condición era `isTablet` a secas, y eso mandaba al
    // capataz —también ciego a partidas— a un paso cuya ruta no lo admite:
    // el guard lo expulsaba del wizard y la actuación quedaba en `partial`.
    // El criterio correcto es el predicado, que cubre a los DOS roles ciegos
    // (`BUDGET_BLIND_ROLES`). Espejo exacto de ActionsValidation/Edition.
    if (!roleCanViewBudgets(currentRole)) {
      navigate('../materials');
    } else {
      navigate('../budget-items');
    }
  };

  return (
    <EditingActionForm
      onFormSubmit={onFormSubmit}
      initialData={loaderData}
      namingPersistForm={formActionNaming.NEW_EDITION_FORM}
      // Horario de la básica: lo calcula el back con el hueco del tramo, y
      // quien hace la básica (también la tablet) lo puede corregir aquí
      // (decisión del usuario, 12-oct).
      basicSchedule={
        loaderData.isBasicAction
          ? { editable: roleCanEditBasicSchedule(currentRole, 'wizard') }
          : undefined
      }
    />
  );
}
